import React from 'react';
import PropTypes from 'prop-types';
import '../../LinkModal.css';

import Button from '../../../common/Button';
import IconClose from '../../../svg/IconClose';
import LogoLink from '../svg/LogoLink';
const LMC = require(`../media/LMC2.png`);

function LinkModal({ cancelClick, modalHasEntered }) {
  const redirect = () => { window.open(`https://www.beatsource.com/subscriptions?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen`, `_blank`) }
  return (
    <div className={`flexColumn linkModal`}>
      <div className={`flexColumn container`}>
        <IconClose size={16} color={`#FAFAFA`} onClick={cancelClick} className={`lm-close-icon`} />
        <img className={`cover2`} src={LMC} alt={`LMC`} />
        <div className={`logo center`}>
          <LogoLink />
        </div>
        <div className={`title type-title center`}>Try the full version free.</div>
        <div className={`description type-regular center`} style={{ margin: `12px 40px 20px 40px` }}>Unlock full previews, exclusive DJ Edits, and integration with your favorite DJ software.</div>
        <div className={`flexRow center`}>
          <Button label={`Try it free`} className={`medium primary type-small lm-button`} onClick={redirect} />
        </div>
      </div>
    </div>
  )
}

LinkModal.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default LinkModal;
